export default __webpack_public_path__ + "static/media/emm-banner.9183cad5.jpg";